const DsfFormulaEditor = Vue.defineAsyncComponent(() => import(/* webpackChunkName: "platform_pc_formula_editor" */ "./formulaEditor.vue"));

export default {
  install(Vue) {
    Vue.component("DsfFormulaEditor", DsfFormulaEditor);
  }
};